module.exports = __webpack_public_path__ + "static/OCRA-066cb712dac739f4094e9fbce737d4bd.woff2";